import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";

const Productsizechart = ({ sizeChartId }) => {
  const [sizeChart, setSizeChart] = useState(null);

  const fetchSizeChart = async () => {
    if (!sizeChartId) return;
    try {
      const res = await fetch(getApiUrl("product-getcharts"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: sizeChartId }) // send id to fetch specific chart
      });
      const result = await res.json();
      if (result.success) setSizeChart(result.data);
    } catch (error) {
      console.log("Failed to fetch size chart");
    }
  };

  useEffect(() => {
    fetchSizeChart();
  }, [sizeChartId]);

  if (!sizeChart) return <p className="mt-3">Loading size chart...</p>;

  return (
    <div className="size-card mt-4 p-3 border rounded">
      <h5 className="chart-title">{sizeChart.chartName}</h5>
      <div className="table-responsive-custom">
        <table className="table shadow-table">
          <thead>
            <tr>
              <th>Size</th>
              <th>Bust</th>
              <th>Waist</th>
              <th>Hip</th>
              <th>Top Length</th>
              <th>Pant Length</th>
              <th>Thigh</th>
            </tr>
          </thead>
          <tbody>
            {sizeChart.sizes?.length > 0 ? (
              sizeChart.sizes.map((item, index) => (
                <tr key={index}>
                  <td>{item.size}</td>
                  <td>{item.bust}</td>
                  <td>{item.waist}</td>
                  <td>{item.hip}</td>
                  <td>{item.topLength}</td>
                  <td>{item.pantLength}</td>
                  <td>{item.thigh}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No size details found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Productsizechart;
